/** biome-ignore-all lint/style/useNamingConvention: allow camel case */
import type {FC, ReactNode} from 'react';
import {putAffiliateTagsToUrl} from '~/common/utils/affiliate_tags';
import {Label} from '~/ViewInvitation/common/Label';
import {Link} from '~library/atoms/Link';
import {Typography} from '~library/atoms/Typography';
import type {IconProps} from '~library/svg/PencilIcon';

import './HostDetailsSection.sass';

type HostDetailsLine = {
  icon: FC<IconProps>;
  iconColor?: string;
  display_text?: string;
  key: string;
  qaId: string;
  hide?: boolean;
} & (
  | {
      value: string | ReactNode;
      type: 'text';
    }
  | {
      value: string;
      type: 'link';
    }
);

interface HostDetailsSectionProps {
  title: string;
  titleQaId: string;
  lines: HostDetailsLine[];
}

export const HostDetailsSection: FC<HostDetailsSectionProps> = ({title, titleQaId, lines}) => {
  if (lines.length === 0) return null;

  return (
    <div className="view-invitation__details-module__section">
      <Label value={title} data-qa-id={titleQaId} />
      <div className="view-invitation__details-module__section-content">
        {lines
          .filter((line) => !line.hide)
          .map((line) =>
            line.type === 'link' ? (
              <Link
                key={line.qaId}
                variant="large"
                data-qa-id={line.qaId}
                href={putAffiliateTagsToUrl(line.value, {
                  tag: 'web-tracking-20',
                  asc_source: 'no|reg',
                })}
                target="_blank"
                className="view-invitation__details-module__line"
              >
                <line.icon ratio={0.5} color={line.iconColor} />
                <Typography
                  as="span"
                  variant="link"
                  className="view-invitation__details-module__line-text"
                >
                  {line.display_text || line.value}
                </Typography>
              </Link>
            ) : (
              <Typography
                key={line.qaId}
                variant="paragraph2"
                data-qa-id={line.qaId}
                data-qa-value={line.value}
                className="view-invitation__details-module__line"
              >
                <line.icon ratio={0.5} color={line.iconColor} />
                <Typography
                  as="span"
                  variant="paragraph2"
                  className="view-invitation__details-module__line-text"
                >
                  {line.display_text || line.value}
                </Typography>
              </Typography>
            )
          )}
      </div>
    </div>
  );
};
